import React, { useEffect, useState } from 'react';
import ApplicantsList from './ApplicantsList';
import ApplicantView from './ApplicantView';
import './Applicants.css';

function Applicants() {
  const [applicants, setApplicants] = useState([]);
  const [filteredApplicants, setFilteredApplicants] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedJobTitle, setSelectedJobTitle] = useState('');
  const [selectedApplicant, setSelectedApplicant] = useState(null);

  // Fetch applicants from API
  useEffect(() => {
    const fetchApplicants = async () => {
      try {
        const res = await fetch('http://localhost:3000/api/applicants');
        if (!res.ok) throw new Error('Failed to fetch applicants');
        const data = await res.json();

        // Normalize for frontend view
        const normalized = data.map((app) => ({
          id: app._id,
          name: app.name,
          email: app.email,
          jobTitle: app.jobTitle,
          dateApplied: new Date(app.appliedAt).toLocaleDateString(),
          resume: app.resumeLink,
          fullData: app, // Keep full object for view modal
        }));

        setApplicants(normalized);
        setFilteredApplicants(normalized);
      } catch (err) {
        console.error(err);
        alert('Error fetching applicants');
      }
    };

    fetchApplicants();
  }, []);

  // Filter based on search term and selected job title
  useEffect(() => {
    let results = applicants;

    if (searchTerm) {
      results = results.filter((app) =>
        app.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        app.email.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (selectedJobTitle) {
      results = results.filter((app) => app.jobTitle === selectedJobTitle);
    }

    setFilteredApplicants(results);
  }, [searchTerm, selectedJobTitle, applicants]);

  const handleView = (applicant) => {
    setSelectedApplicant(applicant.fullData || applicant);
  };

  const handleCloseModal = () => {
    setSelectedApplicant(null);
  };

  const jobTitles = [...new Set(applicants.map((app) => app.jobTitle))];

  return (
    <div className="ApplicantsPage-container">
      <ApplicantsList
        applicants={filteredApplicants}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedJobTitle={selectedJobTitle}
        setSelectedJobTitle={setSelectedJobTitle}
        jobTitles={jobTitles}
        onView={handleView}
      />

      {selectedApplicant && (
        <ApplicantView
          applicant={selectedApplicant}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
}

export default Applicants;
